const ROLE_LEVELS = {
    viewer: 0,
    author: 1,
    reviewer: 2,
    admin: 3,
};
export function hasPermission(userRole, requiredRole) {
    return ROLE_LEVELS[userRole] >= ROLE_LEVELS[requiredRole];
}
export function canCreate(role) {
    return hasPermission(role, 'author');
}
export function canEdit(role, isOwner) {
    if (hasPermission(role, 'admin'))
        return true;
    return isOwner && hasPermission(role, 'author');
}
export function canReview(role) {
    return hasPermission(role, 'reviewer');
}
export function canPublish(role) {
    return hasPermission(role, 'reviewer');
}
export function canAdmin(role) {
    return hasPermission(role, 'admin');
}
